import React, { ReactNode } from "react";
import { Route } from "react-router-dom";

import { Card } from "affinityUI/elements/card";
import { LayoutWrapper } from "affinityUI/structures/layout";

import errorNotFound from "./assets/errorNotFound.svg";
import { ErrorView } from "./errorView";

const NotFoundError: React.FC = () => (
  <LayoutWrapper>
    <Card>
      <ErrorView heading="Page not found" imgSrc={errorNotFound}>
        The page you are looking for couldn’t be found
      </ErrorView>
    </Card>
  </LayoutWrapper>
);

export const pageNotFound: ReactNode = <Route path="*" element={<NotFoundError />} />;
